import React from 'react';
export default function TextMediaAccordionItemContent(props) {
    var item = props.item, i = props.i;
    return (React.createElement(React.Fragment, { key: i },
        React.createElement("div", { className: "row item-content" },
            item.fields.contentColumn1 &&
                React.createElement("div", { className: "col mb-4 mb-lg-0 content-column-one", dangerouslySetInnerHTML: { __html: item.fields.contentColumn1 } }),
            !item.fields.fullWidthColumn1 && item.fields.contentColumn2 &&
                React.createElement("div", { className: "col-lg-6 content-column-two", dangerouslySetInnerHTML: { __html: item.fields.contentColumn2 } })),
        item.fields.fullWidthColumn1 && item.fields.contentColumn2 &&
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col mt-4 content-column-two", dangerouslySetInnerHTML: { __html: item.fields.contentColumn2 } }))));
}
